import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Worker that claimed an assignment.
 * Воркер, который взял задание.
 * Service name links to the workers card; host sits under it. Without a stamp, the fallback label is shown.
 * Имя сервиса ведёт на карточку воркера, хост — под ним. Без штампа показывается запасная подпись.
 */
@Component({
  selector: 'app-assignment-host-label',
  standalone: true,
  imports: [RouterLink, TranslateModule],
  templateUrl: './assignment-host-label.html',
  styleUrl: './assignment-host-label.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignmentHostLabelComponent {
  readonly serviceName = input<string | null | undefined>(null);
  readonly hostName = input<string | null | undefined>(null);
  readonly workerId = input<string | null | undefined>(null);
  readonly fallback = input<string | null | undefined>(null);

  readonly service = computed(() => this.serviceName()?.trim() || null);
  readonly host = computed(() => this.hostName()?.trim() || null);
  readonly workerLink = computed(() => {
    const id = this.workerId()?.trim();
    return id ? ['/admin/orchestration/workers', id] : null;
  });
}
